document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollTrigger);

  // Animate vertical tech bars
  gsap
    .timeline({
      scrollTrigger: {
        trigger: ".timeline-information-parent",
        start: "top 200%",
        end: "top 0%", // full scroll range
        scrub: 1.5,
        markers: false,
      },
    })
    .to(".timeline-information .tech-bar-overlay .tech-bar", {
      height: "0%",
      ease: "none",
      stagger: {
        each: 0.04,
      },
    });

  // ScrollTrigger.refresh();
  const slides = document.querySelectorAll(
    ".timeline-information .splide__slide"
  );
  const track = document.querySelector(".timeline-information .splide__list");
  const timelineSection = document.querySelector(".timeline-information");

  let currentIndex = 0;
  const slideInterval = 3000;
  let observerTriggered = false;

  function isMobile() {
    return window.innerWidth <= 768;
  }

  function getVisibleSlides() {
    let containerWidth = document.querySelector(
      ".timeline-information"
    ).offsetWidth;
    let slideWidth = slides[0].offsetWidth;
    if (isMobile()) {
      return 1.5;
    } else {
      return Math.floor(containerWidth / slideWidth); // Number of slides visible at once
    }
  }

  function animateSlide(index) {
    const visibleSlides = getVisibleSlides();
    const totalSlides = slides.length;
    const currentSlide = slides[index];
    const fill = currentSlide.querySelector(".progress-fill");

    // Add animation classes if not already present
    if (!currentSlide.classList.contains("animate")) {
      currentSlide.classList.add("animate");
      if (fill && !fill.classList.contains("animate")) {
        fill.classList.add("animate");
      }
    }

    // Slide animation (desktop or mobile)
    if (!isMobile()) {
      const slideWidth = slides[0].offsetWidth;
      const maxOffset = slideWidth * (totalSlides - visibleSlides);
      const offset = Math.min(slideWidth * index, maxOffset);

      track.style.transition = "transform 0.5s ease-in-out";
      track.style.transform = `translateX(-${offset}px)`;
    } else {
      track.scrollTo({
        left: currentSlide.offsetLeft,
        behavior: "smooth",
      });
    }

    // Hide progress bar if it's the last slide
    slides.forEach((slide, i) => {
      const bar = slide.querySelector(".progress-bar");
      if (bar) {
        bar.style.opacity =
          i === totalSlides - 1 && index === totalSlides - 1 ? "0" : "";
      }
    });

    // Proceed to next slide or restart
    setTimeout(() => {
      if (index < totalSlides - 1) {
        currentIndex = index + 1;
        animateSlide(currentIndex);
      } else {
        setTimeout(() => {
          resetTimeline(() => {
            animateSlide(0);
          });
        }, 1000); // Pause before looping back
      }
    }, slideInterval);
  }

  function resetTimeline(callback) {
    currentIndex = 0;
    track.style.transition = "none";
    track.style.transform = "translateX(0)";
    void track.offsetWidth; // Force reflow

    slides.forEach((slide) => {
      slide.classList.remove("animate");
      const fill = slide.querySelector(".progress-fill");
      const bar = slide.querySelector(".progress-bar");
      if (fill) {
        fill.classList.remove("animate");
        void fill.offsetWidth;
      }
      if (bar) bar.style.display = "";
    });

    setTimeout(() => {
      if (typeof callback === "function") callback();
    }, 50);
  }

  // Start animation when section scrolls into view
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !observerTriggered) {
          observerTriggered = true;
          animateSlide(currentIndex);
          observer.unobserve(timelineSection);
        }
      });
    },
    { threshold: 0.3 }
  );

  observer.observe(timelineSection);
});
